module.exports = __webpack_public_path__ + "static/media/washington-dc-82.6e248447.jpg";